import { fetchWrapper } from '../Helpers';

const baseUrl = `${process.env.REACT_APP_API_URL}/gallery-images`;

export const galleryService = {
  getAll,
  create,
  delete: _delete,
  updateStatus,
  getVisibleGallery,
};

function getAll(options) {
  let filterString = '';
  if (options && options.page !== undefined) {
    filterString = getAllPaging(options, filterString);
  }
  const url =
    filterString.length > 0 ? `${baseUrl}?${filterString}` : `${baseUrl}`;
  return fetchWrapper.get(url);
}
function getVisibleGallery(options) {
  let filterString = '';
  if (options.filter) {
    filterString = options.filter;
  }
  if (options.page !== undefined) {
    filterString = getAllPaging(options, filterString);
  }
  const url =
    filterString.length > 0 ? `${baseUrl}/visiblegallery?${filterString}` : `${baseUrl}`;
  return fetchWrapper.get(url);
}

function getAllPaging(options, filterString) {
  filterString += filterString.length > 0 ? `&` : '';
  filterString += `page=${options.page}`;
  if (options.pageSize) {
    filterString += filterString.length > 0 ? `&` : '';
    filterString += `per_page=${options.pageSize}`;
  }
  return filterString;
}

/*function getById(id) {
  return fetchWrapper.get(`${baseUrl}/${id}`);
}*/

function create(params) {
  return fetchWrapper.post(baseUrl, params);
}

function updateStatus(id, status) {
  return fetchWrapper.post(`${baseUrl}/${id}/status`, { 'status': status });
}

// prefixed with underscore because 'delete' is a reserved word in javascript
function _delete(id) {
  return fetchWrapper.delete(`${baseUrl}/${id}`);
}
